import { useEffect, useRef } from 'react';
import { useUser } from '../contexts/UserContext';

const DEFAULT_TITLE = 'Localytics | Dominate Locally With Competitive Intelligence';
const DEFAULT_FAVICON = '/destination.ico';
const DEFAULT_APPLE_ICON = '/output.png';

/**
 * Dynamically updates the browser tab title and favicon to reflect
 * white-label branding when an agency has configured custom branding.
 */
export function useWhiteLabelTab() {
  const { brandName, agencyBranding } = useUser();
  const originalFaviconRef = useRef(DEFAULT_FAVICON);
  const originalAppleIconRef = useRef(DEFAULT_APPLE_ICON);

  useEffect(() => {
    if (brandName && brandName !== 'Localytics') {
      document.title = `${brandName} | Competitive Intelligence`;
    } else {
      document.title = DEFAULT_TITLE;
    }

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [brandName]);

  useEffect(() => {
    const logoUrl = agencyBranding?.logo_url;
    const defaultFavicon = originalFaviconRef.current;
    const defaultAppleIcon = originalAppleIconRef.current;

    const faviconLink = document.querySelector('link[rel="icon"]');
    const appleIconLink = document.querySelector('link[rel="apple-touch-icon"]');

    if (logoUrl) {
      if (faviconLink) {
        faviconLink.href = logoUrl;
      }
      if (appleIconLink) {
        appleIconLink.href = logoUrl;
      }
    } else {
      if (faviconLink) {
        faviconLink.href = defaultFavicon;
      }
      if (appleIconLink) {
        appleIconLink.href = defaultAppleIcon;
      }
    }

    return () => {
      if (faviconLink) {
        faviconLink.href = defaultFavicon;
      }
      if (appleIconLink) {
        appleIconLink.href = defaultAppleIcon;
      }
    };
  }, [agencyBranding]);
}
